import React, { ReactNode, useState } from 'react';

import Dropzone, { IDropzoneProps } from '@components/Dropzone';
import { IFileUploaded } from '@modulate/shared/src/models/file';
import FormFieldLabel from './FormFieldLabel';
import { IFormFieldProps } from './models';
import { useFormField } from './useFormField';

interface IProps extends IFormFieldProps {
  children?: ReactNode | ReactNode[];
  uploadFile: (file: File, patientId: string) => Promise<IFileUploaded>;
}

function FormFileField({
  name,
  uploadFile,
  label,
  optional,
  children,
  size = 50,
  ...props
}: IProps & Pick<IDropzoneProps, 'maxFiles' | 'accept' | 'deleteFile' | 'viewFile'>) {
  const { id, meta, fieldProps, setValue } = useFormField<IFileUploaded[]>(name, size);

  const onChangeHandler = async (files: IFileUploaded[], isUploading: boolean) => {
    await setValue(isUploading ? [] : files.filter((file) => file.id));
  };

  return (
    <div {...fieldProps}>
      {label && (
        <FormFieldLabel htmlFor={id} optional={optional}>
          {label}
        </FormFieldLabel>
      )}
      <Dropzone id={id} files={meta.value} upload={uploadFile} onChange={onChangeHandler} {...props}>
        {children}
      </Dropzone>
    </div>
  );
}

export default FormFileField;
